import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import appConfig from '../config/app-config';

@Injectable({
  providedIn: 'root'
})

export class MyAccountService {

  constructor(private http: HttpClient) {
  }

  public getHeader(headers: any) {
    if (headers) {
      headers = new HttpHeaders({'Content-Type': 'application/json', ...headers});
    }
    return {headers};
  }

  public httpGet(url: any, headers?: any) {
    return this.http.get(appConfig.myAccountBaseUrl + url, this.getHeader(headers))
  }

  public httpPost(url: string, body: any, headers?: any) {
    return this.http.post(appConfig.myAccountBaseUrl + url, body, this.getHeader(headers))
  }

  public httpPut(url: string, body: any, headers?: any) {
    return this.http.put(appConfig.myAccountBaseUrl + url, body, this.getHeader(headers))
  }

  public httpDelete(url: string, headers?: any) {
    return this.http.delete(appConfig.myAccountBaseUrl + url, this.getHeader(headers));
  }
}
